import { setStatus, updateDeviceModal } from '../updateDeviceModalSlice';
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from 'react';
import { selector as editDeviceSelector, setEditDeviceData, hideModal } from '../updateDeviceModalSlice';
import { fetchDeviceData } from '../../../pages/deviceManagement/deviceSlice';
import useNotification from '../../notification/useNotification';
import { isSuccessResponse } from '../../../common/utils';
import { IUpdateDevicePayload } from '../../../common/types/devicesTypes';


export const useEditDeviceModal = () => {
    const { isActive, displayName: deviceNameToEdit, deviceId, orgId: groupId } = useSelector(editDeviceSelector);
    const dispatch: any = useDispatch();
    const [newDisplayName, setNewDisplayName] = useState<string>("");

    const handleClose = () => {
        dispatch(hideModal());
        setNewDisplayName(deviceNameToEdit);
        dispatch(setEditDeviceData(null))
    }

    const handleShow = () => {
        setNewDisplayName(deviceNameToEdit);
    };

    useEffect(() => {
        if (isActive) {
            handleShow();
        }
    }, [isActive])

    const { showSuccessNotification, showWarningNotification } = useNotification();
    const handleEditButtonClick = () => {

        if (!newDisplayName || newDisplayName.trim().length === 0) {
            showWarningNotification("Device name cannot be empty or blank spaces.");
            return;
        }

        const updateDevicePayload: IUpdateDevicePayload = {
            deviceId: deviceId,
            body: {
                displayName: newDisplayName.trim(),
                organizationId: groupId
            }
        }
        dispatch(updateDeviceModal(updateDevicePayload)).then((response) => {
            if (isSuccessResponse(response.payload)) {
                dispatch(fetchDeviceData(''));
                dispatch(setStatus());
                showSuccessNotification(response.payload.message);
            }
            else {
                showWarningNotification(response.payload.response?.data?.message);
            }
        });
        dispatch(hideModal());
        dispatch(setEditDeviceData(null))
    };

    return {
        handleEditButtonClick,
        handleClose,
        newDisplayName,
        setNewDisplayName,
        isActive,
        deviceId
    };
}